module.exports = __webpack_public_path__ + "img/ARTarget.f0319533.webp";